export const RESET = 'SQLSCRIPTEXECUTED_LIST_RESET'
export const SET_ITEMS = 'SQLSCRIPTEXECUTED_LIST_SET_ITEMS'
export const SET_ERROR = 'SQLSCRIPTEXECUTED_LIST_SET_ERROR'
export const SET_VIEW = 'SQLSCRIPTEXECUTED_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'SQLSCRIPTEXECUTED_LIST_TOGGLE_LOADING'
